import apiSlice from "../apiSlice";
import type { CategorySummaryType, CategoryType } from "src/layout/main/nav/cats/types";
import type { ProductItemType } from "src/types/products/ProductItem";

interface CategoryProductsFilters {
    page?: number | null;
    search?: string | null;
    start_price?: number | null;
    end_price?: number | null;
    have_discount?: boolean | null;
    order_by?: string | null;
    order_dir?: string | null;
}

export interface CategoryProductsQueryArgs {
    slug: string;
    filters?: CategoryProductsFilters;
}

interface CategoryProductsResponse {
    next: string | null;
    previous: string | null;
    last_page: number;
    count: number;
    results: ProductItemType[];
    category_data: CategorySummaryType;
}

const normalizeCategories = (response: CategoryType[] | null | undefined): CategoryType[] => (
    Array.isArray(response) ? response : []
);

const getCategoryProductsQuery = ({ slug, filters }: CategoryProductsQueryArgs): string => {
    const params = new URLSearchParams();

    if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
            if (value === null || value === undefined || value === '') {
                return;
            }
            params.append(key, String(value));
        });
    }

    return `/categories/${slug}/products/?${params.toString()}`;
};

const catsApiSlice = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        cats: build.query<CategoryType[], void>({
            keepUnusedDataFor: 300,
            query: () => (`/categories/`),
            transformResponse: (response: CategoryType[] | null) => normalizeCategories(response),
        }),
        catProducts: build.query<CategoryProductsResponse, CategoryProductsQueryArgs>({
            keepUnusedDataFor: 120,
            query: ({ slug, filters }) => getCategoryProductsQuery({ slug, filters }),
            providesTags: (result) => result ? [
                ...result.results.map((product) => ({ type: "Product" as const, id: product.id })),
                { type: "Product" as const, id: "CATEGORY_LIST" },
            ] : [{ type: "Product" as const, id: "CATEGORY_LIST" }],
        })
    })
})


export const { useCatsQuery, useCatProductsQuery } = catsApiSlice;
